var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRastering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_rastering@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "26 26 26 -2.30926389e-14 1 -2.30926389e-14 1 25 3 25 14 13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_rastering",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#005082",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    cx: 13,
    cy: 13,
    r: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 13.1111111,
    x2: 22.9166667,
    y2: 23.7695473,
    id: "Path-5",
    stroke: "#005082"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#F36E21",
    fillRule: "nonzero",
    cx: 13,
    cy: 13,
    r: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRastering);
export default __webpack_public_path__ + "static/media/icon_rastering.13c5b6d3d331c80cc071bf1e51e01833.svg";
export { ForwardRef as ReactComponent };